<template>
    <transition
        enter-active-class="transition duration-100"
        enter-class="translate-y-[-30px] opacity-0"
        leave-active-class="transition duration-100"
        leave-to-class="translate-y-[-30px] opacity-0"
    >
        <slot />
    </transition>
</template>
